import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,{staticClass:"fill-height",attrs:{"align-content":"center","justify":"center"}},[_c(VCol,{staticClass:"text-subtitle-1 text-center",attrs:{"cols":"12"}},[_vm._v("\n\t\t"+_vm._s(_vm.text)+"\n\t")]),_c(VCol,{attrs:{"cols":"10"}},[_c(VProgressLinear,{attrs:{"color":_vm.color,"indeterminate":"","rounded":"","height":"6"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }